import { render, staticRenderFns } from "./SlidingUpPanel.vue?vue&type=template&id=264b201e&scoped=true"
import script from "./SlidingUpPanel.vue?vue&type=script&lang=js"
export * from "./SlidingUpPanel.vue?vue&type=script&lang=js"
import style0 from "./SlidingUpPanel.vue?vue&type=style&index=0&id=264b201e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@5.97.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264b201e",
  null
  
)

export default component.exports